module.exports = "/images/vendor/flag-icon-css/flags/1x1/fj.svg?76a7a39e11d32487b82b58046c23e708";